import Docs from "@/views/Documentation/index";
import Introduce from "./../../views/Documentation/Introduce";
import Download from "./../../views/Documentation/Download";
import Tutorial from "./../../views/Documentation/Tutorial";
import Dashboard from "./../../views/Documentation/Dashboard";
import ListContent from "./../../views/Documentation/ListContent";
import AddTask from "./../../views/Documentation/AddTask";
import DetailsContent from "./../../views/Documentation/DetailsContent";
import AIEditorContent from "./../../views/Documentation/AIEditorContent";
import AIClipMaker from "./../../views/Documentation/AIClipMaker";
import VisualizeApp from "./../../views/Documentation/VisualizeApp";
import TimeLineChart from "./../../views/Documentation/TimeLineChart";
import IndexingEcommerce from "./../../views/Documentation/IndexingEcommerce";
import DescriptionJson from "./../../views/Documentation/DescriptionJson";
import AdobePremiere from "./../../views/Documentation/AdobePremiere";
const route = {
  path: "/document",
  name: "Document",
  component: Docs,
  hidden: false,
  meta: {
    title: "Document",
    keepAlive: false,
  },
  children: [
    {
      path: "",
      name: "Introduce",
      component: Introduce,
      meta: {
        title: "Introduce",
        keepAlive: false,
      },
    },
    {
      path: "download",
      name: "Download",
      component: Download,
      meta: {
        title: "Download",
        keepAlive: false,
      },
    },
    {
      path: "tutorial",
      name: "Tutorial",
      component: Tutorial,
      meta: {
        title: "Tutorial",
        keepAlive: false,
      },
    },
    {
      path: "dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        title: "Dashboard",
        keepAlive: false,
      },
    },
    {
      path: "listcontent",
      name: "ListContent",
      component: ListContent,
      meta: {
        title: "ListContent",
        keepAlive: false,
      },
    },
    {
      path: "addtask",
      name: "AddTask",
      component: AddTask,
      meta: {
        title: "AddTask",
        keepAlive: false,
      },
    },
    {
      path: "aieditorcontent",
      name: "AIEditorContent",
      component: AIEditorContent,
      meta: {
        title: "AIEditorContent",
        keepAlive: false,
      },
    },
    {
      path: "detailscontent",
      name: "DetailsContent",
      component: DetailsContent,
      meta: {
        title: "DetailsContent",
        keepAlive: false,
      },
    },
    {
      path: "aiclipmaker",
      name: "AIClipMaker",
      component: AIClipMaker,
      meta: {
        title: "AIClipMaker",
        keepAlive: false,
      },
    },
    {
      path: "aieditorapp",
      name: "VisualizeApp",
      component: VisualizeApp,
      meta: {
        title: "VisualizeApp",
        keepAlive: false,
      },
    },
    {
      path: "timelinechart",
      name: "TimeLineChart",
      component: TimeLineChart,
      meta: {
        title: "TimeLineChart",
        keepAlive: false,
      },
    },
    {
      path: "indexingecommerce",
      name: "IndexingEcommerce",
      component: IndexingEcommerce,
      meta: {
        title: "IndexingEcommerce",
        keepAlive: false,
      },
    },
    {
      path: "descriptionjson",
      name: "descriptionjson",
      component: DescriptionJson,
      meta: {
        title: "DescriptionJson",
        keepAlive: false,
      },
    },
    {
      path: "adobe",
      name: "adobe",
      component: AdobePremiere,
      meta: {
        title: "adobe",
        keepAlive: false,
      },
    },
  ],
};
export default route;
